import { useCallback, useEffect, useState } from "react";
import Cookies from "js-cookie";

const POLL_MS = 60000;

// Messages to the signed-in contributor (their ship or edit was approved / rejected).
// Polls once a minute and whenever the tab becomes visible again.
export default function useNotifications(API_BASE, account) {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const username = account?.username;

  const refresh = useCallback(() => {
    const session = Cookies.get("session");
    if (!username || !session) return Promise.resolve();
    return fetch(`${API_BASE}/api/notifications`, { headers: { Authorization: `Bearer ${session}` }, cache: "no-store" })
      .then((r) => r.json())
      .then((d) => {
        if (Array.isArray(d?.items)) { setItems(d.items); setUnread(d.unread || 0); }
      })
      .catch(() => {});
  }, [API_BASE, username]);

  useEffect(() => {
    if (!username) { setItems([]); setUnread(0); return undefined; }
    refresh();
    const timer = setInterval(refresh, POLL_MS);
    const onVisible = () => { if (document.visibilityState === "visible") refresh(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => { clearInterval(timer); document.removeEventListener("visibilitychange", onVisible); };
  }, [username, refresh]);

  // ids: array of notification ids, or "all"
  const markRead = useCallback((ids) => {
    const session = Cookies.get("session");
    const all = ids === "all";
    const targets = all ? items.filter((n) => !n.read).map((n) => n.id) : ids;
    if (!session || targets.length === 0) return;
    // optimistic: the badge drops straight away
    setItems((list) => list.map((n) => (all || targets.includes(n.id) ? { ...n, read: true } : n)));
    setUnread((u) => (all ? 0 : Math.max(0, u - targets.length)));
    fetch(`${API_BASE}/api/notifications`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(all ? { session, all: true } : { session, ids: targets }),
    }).catch(() => refresh());
  }, [API_BASE, items, refresh]);

  return { items, unread, refresh, markRead };
}
